<template>
  <b-container fluid class='container-form-reset-password'>
      <form novalidate class="md-layout form-reset-password" :class="sectionw.class_color" @submit.prevent="validateContact">
          <md-field :class="getValidationClass('password')" class="form-mb-5">
              <label for="first-last-name">Nueva contraseña</label>
              <md-input type="password" name="first-last-name" id="first-last-name" class="input-black" autocomplete="given-name"
                      v-model="form.password" :disabled="sending"/>
              <span class="md-error" v-if="!$v.form.password.required">La contraseña es requerida</span>
              <span class="md-error" v-else-if="!$v.form.password.minlength">Contraseña inválida</span>
          </md-field>

          <md-field :class="getValidationClass('confirm_password')" class="form-mb-5">
              <label for="first-last-name">Repetir nueva contraseña</label>
              <md-input type="password" name="first-last-name" id="first-last-name" class="input-black" autocomplete="given-name"
                      v-model="form.confirm_password" :disabled="sending"/>
              <span class="md-error" v-if="!$v.form.confirm_password.required">La contraseña es requerida</span>
              <span class="md-error" v-else-if="!$v.form.confirm_password.minlength">Contraseña inválida</span>
          </md-field>
  
  
          <div class="md-field formulario-center-button">
              <div  id="formulario-boton">
              <button v-if="sectionw.boton_img" type="submit" :disabled="sending" class="button-primary-global">
                      <span class="button-text-global">
                          {{ sectionw.text_boton }}
                           <img src="@/assets/images/arrow_left.svg" alt="Left Arrow img">
                      </span>
              </button>
              <button v-else type="submit" :disabled="sending" class="button-primary-global">
                  <span class="button-text-global-normal"> {{ sectionw.text_boton }} </span>
              </button>
              </div>
          </div>
        <div class="md-field formulario-center-button" v-if="showDismissibleAlert">
            <div class="mt-1 pb-1">
            <b-alert style="text-align: center" id="alert-send" class="alert-sended"
                    v-model="showDismissibleAlert"  dismissible>
                <span> Se cambió correctamente la contraseña, revise su correo o <br>ingrese a la App Gox</span>
            </b-alert>
            </div>
        </div>
        <div class="md-field formulario-center-button" v-if="showDismissibleAlertError">
            <div class="mt-1 pb-1">
            <b-alert style="text-align: center" id="alert-send-ganger" variant="danger"
                    v-model="showDismissibleAlertError"  dismissible>
                <span> {{ msgErrorPassword }}</span>
            </b-alert>
            </div>
        </div>
          <div class="vld-parent">
              <loading :active.sync="sending"
                      :can-cancel="true"
                      loader="dots"
                      color="#FFC100"
                      backgroundColor="black"
                      :width=128
                      :height=128
                      :is-full-page="true">
              </loading>
          </div>
      </form>
  </b-container>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    //import axios from 'axios'
    import {
      required,
      minLength,
      maxLength,
    } from 'vuelidate/lib/validators'
    //import CountryFlag from 'vue-country-flag'

  export default {
    name: 'formulario-new-password',
    mixins: [validationMixin],
    components: {Loading},
    props: {content: Object},
    data: () => ({
        sectionw: {
          class_color: 'formulario-black',
          text_boton: 'Enviar',
          boton_img: false
        },
        form: {
                password: null,
                confirm_password: null
        },
        contactSaved: false,
        sending: false,
        lastUser: null,
        showDismissibleAlert: false,
        showDismissibleAlertError: false,
        msgErrorPassword: null
      }),
    mounted () {},
    validations: {
            form: {
                password: {
                    required,
                    minLength: minLength(0),
                    maxLength: maxLength(30)
                },
                confirm_password: {
                    required,
                    minLength: minLength(0),
                    maxLength: maxLength(30)
                }
            }
    },
    methods: {
        getValidationClass (fieldName) {
          const field = this.$v.form[fieldName]
  
          if (field) {
            return {
              'md-invalid': field.$invalid && field.$dirty
            }
          }
        },
        clearForm () {
          this.$v.$reset()
          this.form.password = null
          this.form.confirm_password = null
        },
        saveContact () {

          this.sending = true

          if(this.form.password != this.form.confirm_password) {
            this.sending = false
            this.showDismissibleAlertError= true
            this.clearForm()
            this.msgErrorPassword = 'Error: Contraseñas diferentes.'
            return
          }

          this.form.url = 'https://www.google.com'
          this.form.token = this.$route.query.token
          
          
          this.$store.dispatch('setPasswords', this.form)
            .then(() => {
              this.showDismissibleAlert = true
              // this.lastUser = `${this.form.name} ${this.form.phone}`
              this.contactSaved = true
              this.sending = false
              this.clearForm()
  //            alert('Pronto sera atendido por uno de nuestros equipos GOX')
              /*revisar esto es para la barra de carga*/
  //            window.setTimeout(() => {
  //              this.lastUser = `${this.form.name} ${this.form.phone}`
  //              this.contactSaved = true
  //              this.sending = false
  //              this.clearForm()
  //            }, 1500)
            })
            .catch(() => {
              this.sending = false
              this.showDismissibleAlertError= true
              this.msgErrorPassword = 'Error: Token expirado.'
            })
          // Instead of this timeout, here you can call your API
  
        },
        countDownChanged(dismissCountDown) {
          this.dismissCountDown = dismissCountDown
        },
        validateContact () {
          this.$v.$touch()
          if (!this.$v.$invalid) {
            this.saveContact()
          }
        },
        doAjax() {
          this.isLoading = true;
          // simulate AJAX
          setTimeout(() => {
            this.isLoading = false
          },5000)
        },
        onCancel() {
          // console.log('User cancelled the loader.')
        }
      }
  }
</script>
<style scoped>
.container-form-reset-password{

  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  }

.form-reset-password{

  width: 50%;
  height: 30%;
  }

@media (max-width: 600px) {
  .form-reset-password{
      width: 100%;

  }
}

</style>